import { useContext } from 'react';
import { AuthContext } from 'core/components/auth';

function useSession() {
  return useContext(AuthContext);
}

export default useSession;
